import React, { useEffect, useState } from "react";
import "./Header.css";
import { FaBell } from "react-icons/fa";
import cafeLogo from "../../Assets/logo/KanchiLogo.png"; // add your logo here

const CafeHeader = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Live Timer
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    return date.toLocaleDateString("en-IN", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString("en-IN");
  };

  return (
    <header className="cafe-header-container">
      {/* LEFT SECTION */}
      <div className="cafe-brand-section">
        <img src={cafeLogo} alt="Kanchi Cafe Logo" className="cafe-brand-logo" />
      </div>

      {/* CENTER SECTION */}
      <div className="cafe-dashboard-title">
        Operational Dashboard
      </div>

      

      {/* RIGHT SECTION */}
      <div className="cafe-time-section">
        <div className="cafe-date-text">
          {formatDate(currentTime)}
        </div>

        <div className="cafe-time-row">
           <FaBell className="cafe-notification-icon" /><span className="cafe-live-time">
            {formatTime(currentTime)}
          </span>

         
        </div>
      </div>
    </header>
  );
};

export default CafeHeader;